module.exports = __webpack_public_path__ + "img/jm2.078fc44a.png";